import React from 'react';
import { useTranslation } from 'react-i18next';
import './integrations.css';

/**
 * Placeholder affiché quand l'intégration n'est pas configurée
 * Invite l'utilisateur à configurer JIRA/GitHub
 */
const IntegrationPlaceholder = ({ provider, onConfigure }) => {
  const { t } = useTranslation();
  
  const getIcon = () => {
    if (provider === 'atlassian') return '🔷';
    if (provider === 'github') return '🐙';
    if (provider === 'gitlab') return '🦊';
    return '🔌';
  };

  const getName = () => {
    if (provider === 'atlassian') return 'JIRA';
    if (provider === 'github') return 'GitHub';
    if (provider === 'gitlab') return 'GitLab';
    return provider;
  };

  return (
    <div className="integration-placeholder">
      <div className="integration-placeholder-icon">{getIcon()}</div>
      <h3>{t('jiraIntegration.setup.title')}</h3>
      <p>{t('jiraIntegration.setup.notConfigured')}</p>
      <button
        onClick={onConfigure}
        className="integration-button integration-button-primary"
      >
        {t('jiraIntegration.setup.configure')}
      </button>
      <small className="integration-placeholder-security">
        {t('jiraIntegration.security.encryption')}
      </small>
    </div>
  );
};

export default IntegrationPlaceholder;
